import * as Types from '../../__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetStorageAccessFlagsVariables = Types.Exact<{
  belongsTo?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetStorageAccessFlags = { __typename?: 'Query', getStorages?: Array<{ __typename?: 'STORAGE', id: string, isIotMonitoringEnabled?: boolean | null, isQRSystemEnabled?: boolean | null } | null> | null };


export const GetStorageAccessFlagsDocument = gql`
    query GetStorageAccessFlags($belongsTo: ID) {
  getStorages(belongsTo: $belongsTo) {
    id
    isIotMonitoringEnabled
    isQRSystemEnabled
  }
}
    `;

/**
 * __useGetStorageAccessFlags__
 *
 * To run a query within a React component, call `useGetStorageAccessFlags` and pass it any options that fit your needs.
 * When your component renders, `useGetStorageAccessFlags` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorageAccessFlags({
 *   variables: {
 *      belongsTo: // value for 'belongsTo'
 *   },
 * });
 */
export function useGetStorageAccessFlags(baseOptions?: Apollo.QueryHookOptions<GetStorageAccessFlags, GetStorageAccessFlagsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStorageAccessFlags, GetStorageAccessFlagsVariables>(GetStorageAccessFlagsDocument, options);
      }
export function useGetStorageAccessFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStorageAccessFlags, GetStorageAccessFlagsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStorageAccessFlags, GetStorageAccessFlagsVariables>(GetStorageAccessFlagsDocument, options);
        }
// @ts-ignore
export function useGetStorageAccessFlagsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetStorageAccessFlags, GetStorageAccessFlagsVariables>): Apollo.UseSuspenseQueryResult<GetStorageAccessFlags, GetStorageAccessFlagsVariables>;
export function useGetStorageAccessFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStorageAccessFlags, GetStorageAccessFlagsVariables>): Apollo.UseSuspenseQueryResult<GetStorageAccessFlags | undefined, GetStorageAccessFlagsVariables>;
export function useGetStorageAccessFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStorageAccessFlags, GetStorageAccessFlagsVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStorageAccessFlags, GetStorageAccessFlagsVariables>(GetStorageAccessFlagsDocument, options);
        }
export type GetStorageAccessFlagsHookResult = ReturnType<typeof useGetStorageAccessFlags>;
export type GetStorageAccessFlagsLazyQueryHookResult = ReturnType<typeof useGetStorageAccessFlagsLazyQuery>;
export type GetStorageAccessFlagsSuspenseQueryHookResult = ReturnType<typeof useGetStorageAccessFlagsSuspenseQuery>;
export type GetStorageAccessFlagsQueryResult = Apollo.QueryResult<GetStorageAccessFlags, GetStorageAccessFlagsVariables>;